import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// import { MuiThemeProvider } from '@material-ui/core/styles';
import { ThemeProvider } from '@mui/material/styles';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import theme from './components/layout/theme';
// import LayoutWrapper from './components/layout';
import { Layout } from './components/layout/next/layout.jsx';
import clientRoutes from './config/clientroutes.js';
import { RouteFetcher } from '@mk-redbox/route-fetcher';
import { inactiveTimer } from './modules/inactiveTimer/inactiveTimer.js';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const run = () => {
  root.render(
    <RouteFetcher
      // routesUrl="https://routingapidev.mymedkoder.com:44398/api/Routes?version=2"
      renderApp={backendRoutes => {
        inactiveTimer(backendRoutes);
        return (
          <BrowserRouter>
            <ThemeProvider theme={theme}>
              <Layout getClientRoutes={clientRoutes(backendRoutes)} backendRoutes={backendRoutes} />
            </ThemeProvider>
          </BrowserRouter>
        );
      }
      }
    />
  );
};

export { run };
